interface soundDefinition {
    filename: string,
    volume: number,
    loop?: boolean,
}

export class SoundManager {
    sfx: Record<string, HTMLAudioElement> = {};
    music: HTMLAudioElement;

    constructor() {
        const definitions: Record<string, soundDefinition> = {
            'drop': {filename: 'drop.wav', volume: 0.6}, // 149719 // high
            'drop2': {filename: 'drop2.wav', volume: 0.5}, // 425209 // low
            'drop3': {filename: 'drop3.wav', volume: 0.6}, // 530359
            'pour': {filename: 'cork.wav', volume: 0.6}, // 506142
            'bubbling': {filename: 'bubbling.wav', volume: 0.4, loop: true}, // 591151
            'ding': {filename: 'ding.wav', volume: 0.4}, // 415510
            'coins1': {filename: 'coins1.wav', volume: 0.5}, // 492017
            'clack': {filename: 'click.wav', volume: 0.4}, // 391697
            'click': {filename: 'little-click2.wav', volume: 0.8, loop: true}, // 536108
            'boom': {filename: 'boom.wav', volume: 0.3}, // 368642
            'bad': {filename: 'bad.wav', volume: 0.4}, // 380265
            'star1': {filename: 'star1.wav', volume: 0.5}, // 320654
            'star2': {filename: 'star2.wav', volume: 0.5}, // 320655
            'star3': {filename: 'star3.wav', volume: 0.5}, // 320657
            'win': {filename: 'win.wav', volume: 0.5}, // 320887
            'page': {filename: 'page1.wav', volume: 0.7}, // 449127
            'page2': {filename: 'page2.wav', volume: 0.7}, // 449127
            'whoosh': {filename: 'whoosh.wav', volume: 0.6},// 430077
            'thump': {filename: 'thump.wav', volume: 0.5},// 458877
        };
        
        for (let name in definitions) {
            var def = definitions[name];
            var sound = new Audio(`assets/sounds/${def.filename}`);
            sound.volume = def.volume;
            sound.loop = def.loop;
            this.sfx[name] = sound;
        }

        // music from https://audionautix.com/
        this.music = new Audio('assets/sounds/CoolRide.mp3');
        this.music.volume = 0.1;
        this.music.loop = true;
    }

    start() {
        this.playMusic();
    }

	playMusic(play = true) {
		if (play) {
			this.music.play();
		}
		else {
			this.music.pause();
		}
	}

    play(sound: string) {
        if (this.sfx[sound]) {
            if (this.sfx[sound].loop) {
                this.sfx[sound].play();
            }
            else {
                // Clone and play to get multiples
                var clone = this.sfx[sound].cloneNode(true) as HTMLAudioElement;
                clone.volume = this.sfx[sound].volume;
                clone.play();
            }
        }
    }

    stop(sound: string) {
        if (this.sfx[sound]) {
            this.sfx[sound].pause();
        }
    }
}

export const sounds = new SoundManager();